<div class="p-1 pt-3">

  <a routerLink="/users" class="btn btn-sm btn-outline-secondary mb-3">
    <i class="bi bi-chevron-left me-1"></i>Back to users
  </a>

  @if (loading()) {
    <div class="text-muted py-4 text-center">
      <span class="spinner-border spinner-border-sm me-2" role="status"></span>Loading…
    </div>
  } @else if (error()) {
    <div class="alert alert-danger">{{ error() }}</div>
  } @else {
    @let u = user();
    @if (u) {

      <div class="d-flex align-items-center gap-2 mb-4">
        <h4 class="mb-0">{{ u.name || u.email }}</h4>
        <span class="badge bg-secondary">{{ u.type }}</span>
        <span class="badge bg-light text-dark border">{{ u.status }}</span>
      </div>

      @if (actionError()) {
        <div class="alert alert-danger">{{ actionError() }}</div>
      }

      <div class="row g-4">
        <!-- Details / edit -->
        <div class="col-lg-8">
          <div class="card mb-4">
            <div class="card-header fw-semibold"><i class="bi bi-person-lines-fill me-2"></i>Details</div>
            <div class="card-body">
              <div class="mb-3">
                <label for="name" class="form-label">Name</label>
                <input
                  id="name"
                  type="text"
                  class="form-control"
                  [ngModel]="name()"
                  (ngModelChange)="name.set($event)"
                >
              </div>
              <div class="mb-3">
                <label class="form-label">Email</label>
                <input type="text" class="form-control" [value]="u.email" disabled>
                <div class="form-text">Email and type are not editable via the API.</div>
              </div>
              <button class="btn btn-primary" (click)="save()" [disabled]="saving()">
                @if (saving()) {
                  <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                }
                Save
              </button>
            </div>
          </div>
        </div>

        <!-- Metadata / danger zone -->
        <div class="col-lg-4">
          <div class="card mb-4">
            <div class="card-header fw-semibold"><i class="bi bi-info-circle me-2"></i>Metadata</div>
            <ul class="list-group list-group-flush small">
              <li class="list-group-item d-flex justify-content-between">
                <span class="text-muted">Type</span><span>{{ u.type }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <span class="text-muted">Status</span><span>{{ u.status }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <span class="text-muted">Created</span><span>{{ u.created | date:'d MMM y, HH:mm' }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <span class="text-muted">Updated</span>
                <span>{{ u.updated ? (u.updated | date:'d MMM y, HH:mm') : '—' }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <span class="text-muted">ID</span><span class="font-monospace">{{ u.id }}</span>
              </li>
            </ul>
          </div>

          <div class="card border-danger mb-4">
            <div class="card-header fw-semibold text-danger"><i class="bi bi-exclamation-triangle me-2"></i>Danger zone</div>
            <div class="card-body">
              <button class="btn btn-outline-danger" (click)="remove()" [disabled]="deleting()">
                @if (deleting()) {
                  <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                }
                <i class="bi bi-trash me-1"></i>Delete user
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  }
</div>
